export interface IWatchfolderResult {
    content: IWatchfolder[]
    pageable: IPageable
    last: boolean
    totalPages: number
    totalElements: number
    size: number
    number: number
    sort: ISort
    numberOfElements: number
    first: boolean
    empty: boolean
}

export interface IWatchfolder {
    id: string
    label: string
    path: string
    enabled: boolean
    status: string
    errorMessage: string
    pollingIntervalMs: number
    stabilityDelaySec: number
    allowedExtensions: string[]
    targetService: string
    targetConfig: TargetConfig
    createdTimestamp: string
}

export interface TargetConfig {
    usePathTranslation?: boolean
    pathTranslationLocal?: string
    pathTranslationRemote?: string
    [key: string]: any
}

export interface IPageable {
    pageNumber: number
    pageSize: number
    sort: ISort
    offset: number
    paged: boolean
    unpaged: boolean
}

export interface ISort {
    empty: boolean
    sorted: boolean
    unsorted: boolean
}

export const emptyWatchfolder: IWatchfolder = {
    id: "new_0",
    label: '',
    path: '',
    status: '',
    allowedExtensions: [],
    enabled: true,
    pollingIntervalMs: 10000,
    targetService: "MEDIAENGINE",
    targetConfig: {},
    stabilityDelaySec: 5,
    createdTimestamp: "",
    errorMessage: ""
}

export interface IWatchfolderEngine {
    id: string
    label: string
    configSchema: IEngineConfigSchema
}

export interface IWatchfolderEngineProfile {
    uuid?: string
    label?: string
    description?: string
    displayName?: string
    href?: string
}

export interface IEngineConfigSchema {
    priorityValues: string[]
    profileEndpoint: string
    modifiableValues: string[]
}
